import React from 'react';

import { cssMap } from '@atlaskit/css';
import CheckMarkIcon from '@atlaskit/icon/core/check-mark';
import CrossCircleIcon from '@atlaskit/icon/core/cross-circle';
import { Flex, Inline, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

export type SystemMessageVariant = 'success' | 'error';

type Props = {
	message: string;
	variant?: SystemMessageVariant;
};

const styles = cssMap({
	explainerContainer: {
		paddingTop: token('space.150'),
		paddingBottom: token('space.150'),
		paddingLeft: token('space.150'),
		paddingRight: token('space.150'),
		gap: token('space.150'),
	},
	explainer: {
		paddingTop: token('space.050'),
		paddingBottom: token('space.050'),
		paddingLeft: token('space.100'),
		paddingRight: token('space.100'),
		gap: token('space.075'),
		borderRadius: token('radius.full'),
		border: `${token('border.width')} solid ${token('color.border')}`,
	},
});

export const SystemMessage = ({ message, variant = 'success' }: Props): React.JSX.Element => {
	const Icon = variant === 'error' ? CrossCircleIcon : CheckMarkIcon;
	const iconColor = variant === 'error' ? token('color.icon.danger') : token('color.text.success');

	return (
		<Flex
			xcss={styles.explainerContainer}
			alignItems="center"
			justifyContent="center"
			direction="column"
		>
			<Inline xcss={styles.explainer} alignBlock="center" alignInline="center">
				<Icon label="" color={iconColor} />
				<Text>{message}</Text>
			</Inline>
		</Flex>
	);
};
